<div *ngIf="globals.Session;else loginNav">
  <div #tray class="notification-tray" *ngIf="toggleTray">

    <!-- this is the scroll container -->
    <div #trayCon class="tray-container">
      <div class="tray-header">
        <p class="tray-title">Notifications</p>
      </div>
      <!-- <div class="tray-content" *ngIf="notifications.length > 0;else noTray">
        <div [ngClass]="{'tray-items': true, 'isUnread':!toaster.IsRead}" *ngFor="let toaster of notifications" (click)="selectNotification(toaster.NotificationId)">
          <div>
            <div class="toaster-group">
              <p [ngClass]="{'toaster-title': true, 'info': toaster.NotificationType.toLowerCase() == 'info', 'warning': toaster.NotificationType.toLowerCase() == 'warning', 'error': toaster.NotificationType.toLowerCase() == 'error'}">{{toaster.NotificationTitle}}</p>
              <p class="toaster-date">{{toaster.NotificationDate | date:'d MMM yyyy h:mm:ss aa' }}</p>
            </div>
            <p class="toaster-desc" [innerHTML]="toaster.NotificationMessage"></p>
          </div>
        </div>
      </div> -->

      <div class="tray-content" *ngIf="notifications.length > 0;else noTray" style="height: 100%;">
        <virtual-scroller #scroll [items]="notifications" [parentScroll]="trayCon" (vsUpdate)="viewPortItems = $event" (vsChange)="fetchMore($event)" class="notifications-scroller">

          <div [ngClass]="{'tray-items': true, 'isUnread':!toaster.IsRead}" *ngFor="let toaster of scroll.viewPortItems" (click)="selectNotification(toaster.NotificationId)">
            <div>
              <div class="toaster-group">
                <p [innerHTML]="toaster.NotificationTitle"
                [ngClass]="{'toaster-title': true, 'info': toaster.NotificationType.toLowerCase() == 'info', 'warning': toaster.NotificationType.toLowerCase() == 'warning', 'error': toaster.NotificationType.toLowerCase() == 'error'}">
                
                </p>
                <p class="toaster-date">{{toaster.NotificationDate | date:'d MMM yyyy h:mm:ss aa' }}</p>
              </div>
              <p class="toaster-desc" [innerHTML]="toaster.NotificationMessage"></p>
            </div>
          </div>
            
          <div *ngIf="isFetching" class="loader-fetch">Loading...</div>
        </virtual-scroller>
      </div>
      <ng-template #noTray>
        <p>No new notifications</p>
      </ng-template>


      <!-- <ng-template #noTray>
        <p>No new notifications</p>
      </ng-template> -->
    </div>
    <!-- end (vsUpdate)="viewPortItems = $event" (vsChange)="fetchMore($event)" -->

    

  </div>
  <nav class="navbar navbar-light fixed-top navbar-expand-lg nav-section" *ngIf="displayMenu">
    <!-- <div class="color-scheme-box">
      <a (click)="changeTheme('#ffc83d', '#ffc83d', '#fcfaf5')" class="color-scheme color-one"></a>
      <a (click)="changeTheme('#ed1c24', '#d01d22', '#faeced')" class="color-scheme color-two"></a>
      <a (click)="changeTheme('#3aafda', '#4A98DC')" class="color-scheme color-three"></a>
    </div>  -->
    <div class="new-div">
      <a class="navbar-brand logo" [ngClass]="{'disabled': isHomeClicked, 'default': startPage}" (click)="goToHome()">
        <img src="../../assets/images/portal_logo.png">
      </a> 
      <button [ngClass]="{'navbar-toggler': true, 'collapsed': !navbarOpen }" type="button" data-toggle="collapse" data-target="#navbarCollapse" 
      (click)="toggleNavbar()" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="icon-bar top-bar"></span>
        <span class="icon-bar middle-bar"></span>
        <span class="icon-bar bottom-bar"></span>
        <span class="sr-only">Toggle navigation</span>
      </button>
      <div [ngClass]="{'collapse navbar-collapse':true, 'show': navbarOpen}" >
        <!-- <ul id="primaryMenuBar" class="navbar-nav mr-auto">
          <li class="nav-item" *ngFor="let menuItem of menuActions;">
            <ng-container *ngIf="!menuItem.SubActions; else subactions">
              <a *ngIf="!menuItem.ActionCommand" class="action-group">{{menuItem.ActionDisplay}}</a>
              <a *ngIf="menuItem.ActionCommand" (click)="selectMenuHeader(menuItem.ActionCommand);" [ngClass]="{'active':menuItem.ActionCommand == currentMenu}">{{menuItem.ActionDisplay}}</a>
            </ng-container>
            <ng-template #subactions>
              <div #dp="bs-dropdown" class="btn-group res extra-menu" dropdown triggers="click">
                <button dropdownToggle class="btn dropdown-cs arrow-right no-outline" type="button" 
                  id="dropdownMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{menuItem.ActionName}}
                </button>
                <ul class="dropdown-menu dropdown-menu-cs" *dropdownMenu role="menu" aria-labelledby="dropdownMenu" style="width:auto">
                  <li *ngFor="let subMenu of menuItem.SubActions;" class="nav-item">
                    <span *ngIf="!subMenu.ActionCommand" class="dropdown-item action-group" (click)="dp.show()">{{subMenu.ActionDisplay}}</span>
                    <a *ngIf="subMenu.ActionCommand" [ngClass]="{'dropdown-item': true, 'active':subMenu.ActionCommand == currentMenu}" (click)="selectMenuHeader(subMenu.ActionCommand);">{{subMenu.ActionDisplay}}</a>
                  </li>
                </ul>
              </div>
            </ng-template>
          </li>
          <!-- <li *ngIf="extraMenuActions.length > 0">
            <div #dp="bs-dropdown" class="btn-group res extra-menu" dropdown triggers="click">
              <button dropdownToggle class="btn dropdown-cs arrow-right no-outline" type="button" 
                id="dropdownMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Show More
              </button>
              <ul class="dropdown-menu dropdown-menu-cs" *dropdownMenu role="menu" aria-labelledby="dropdownMenu" style="width:auto">
                <li *ngFor="let extra of extraMenuActions;" class="nav-item">
                  <a [ngClass]="{'dropdown-item': true, 'active':extra.ActionCommand == currentMenu}" (click)="selectMenuHeader(extra.ActionCommand);">{{extra.ActionDisplay}}</a>
                </li>
              </ul>
            </div>
          </li>
        </ul> -->
        <ul class="nav navbar-nav">
          <!-- <li class="nav-item" (click)="getLatest()">getLatest</li> -->
          <li class="nav-item" [class.default]="startPage" *ngIf="!shortHeader && ShowDateTime">
            <div *ngIf="startPage" class="timeZone-container">
              <span *ngIf="datePipe" class="time float-left">{{ datePipe }}</span>
              <span *ngIf="datePipe" class="divider float-left"> | </span>
              <span style="font-size: 13px;color: var(--primary);margin: 0 5px;">{{timeZoneName}}</span>
            </div>
            <div *ngIf="!startPage" class="timeZone-container" [class.opened]="opened">
              <span *ngIf="datePipe" class="time float-left">{{ datePipe }}</span>
              <span *ngIf="datePipe" class="divider float-left"> | </span>
              <ng-container>
                <ng-select #timeZone
                  [items]="timeZoneList"
                  bindLabel="TimeZoneName"
                  bindValue="Id"
                  class="portalTimeZone dropdown-ng-select no-border" 
                  (change)="onTimeZoneChange($event.Id)"
                  (open)="opened = true"
                  (close)="opened = false"
                  [clearable] = "false"
                  [searchable]="false"
                  placeholder="Please Select"
                  [(ngModel)]="timeZoneName">
                  <ng-template ng-header-tmp>
                    <input class="custom-input-search" type="text" (input)="timeZone.filter($event.target.value)" placeholder="Type to search.."/>
                  </ng-template>
                </ng-select>
              </ng-container>
            </div>
          </li>
          <li class="nav-item flag-container" *ngIf="!shortHeader && ShowLanguage">
            <div class="btn-group res" dropdown>
              <button dropdownToggle class="btn dropdown-language arrow-down no-outline {{ globals.Session.Session.LanguageSetting }}" type="button"
                  id="dropdownMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <!-- <span [class.short-flag]="shortHeader"> -->
                    <img [src]="'../../assets/images/' + globals.Session.Session.LanguageSetting + '.png'">
                  <!-- </span> -->
                    {{ currentLanguageDisplay ? currentLanguageDisplay : 
                      globals.Session.Session.LanguageSetting }}
              </button>
              <ul class="dropdown-menu dropdown-menu-language" *dropdownMenu role="menu" aria-labelledby="dropdownMenu" style="width:auto">
                <li *ngFor="let language of languageList">
                  <a class="dropdown-item {{language.SelectionValue}}" (click)="selectLanguage(language.SelectionValue)">
                    <img [src]="'../../assets/images/' + language.SelectionValue + '.png'">
                    {{language.SelectionDisplay}}</a>
                </li>
              </ul>
            </div>
          </li>
          
          <li class="nav-item" *ngIf="!startPage && shortHeader" style="cursor: default;">
            <span *ngIf="communityList.length == 1; else menu" class="short-com">
              <ng-container *ngIf="showCompanyLogo">
                <img [src]="'../../assets/company-logo/logo_' + globals.Session.Session.CommunityId + '.png'" (error)="onErrorImage($event)">  
              </ng-container>
              <ng-container *ngIf="!showCompanyLogo">
                <mat-icon class="com-photo">photo</mat-icon>
              </ng-container>
              {{currentCommunity}}
            </span>
            <div #menu class="btn-group res short-com-dp" *ngIf="communityList.length > 1" dropdown>
              <button dropdownToggle class="btn dropdown-help arrow-down no-outline" type="button" 
                  id="dropdownMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <ng-container *ngIf="showCompanyLogo">
                    <img [src]="'../../assets/company-logo/logo_' + globals.Session.Session.CommunityId + '.png'" (error)="onErrorImage($event)">  
                  </ng-container>
                  <ng-container *ngIf="!showCompanyLogo">
                    <mat-icon class="com-photo">photo</mat-icon>
                  </ng-container>
                  {{currentCommunity}}
              </button>
              <ul class="dropdown-menu dropdown-menu-help" *dropdownMenu role="menu" aria-labelledby="dropdownMenu" style="width:auto">
                <li *ngFor="let community of communityList">
                  <a class="dropdown-item" (click)="changeCommunity(community)">{{community.SelectionDisplay}}</a>
                </li>  
              </ul>
            </div>
          </li>

          <li class="nav-item" [class.default]="startPage">
            <div class="default-profile" *ngIf="startPage">
              <button class="btn dropdown-profile no-outline not-editable">
                  <div class="profile-icon">
                    <mat-icon>person</mat-icon>
                  </div>
                  {{ globals.Session.Session.UserName }}
              </button>
            </div>

            <div *ngIf="!startPage" class="btn-group res" dropdown [insideClick]="true">
              <button dropdownToggle class="btn dropdown-profile arrow-down no-outline" type="button" (click)="getMenuActions()"
                  id="dropdownMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <div class="profile-icon">
                    <mat-icon>person</mat-icon>
                  </div>
                  {{ globals.Session.Session.UserName }}
              </button>
              <ul class="dropdown-menu dropdown-menu-profile" *dropdownMenu role="menu" aria-labelledby="dropdownMenu" style="width:auto">
                  <li class="dropdown-item display-name">
                    <p *ngIf="globals.Session.Session">{{ globals.Session.Session.DisplayName }}</p>
                    <p *ngIf="globals.Session.Session">{{ globals.Session.Session.Email }}</p>
                    <ng-container *ngIf="!shortHeader">
                      <span *ngIf="communityList.length == 1; else menu" style="font-weight: 600;padding: 4px 0 1px;display: block;">{{currentCommunity}}</span>
                      <ng-template #menu>
                        <div *ngIf="communityList.length > 1" style="height: 30px;">
                          <ng-select class="dropdown-ng-select no-border community-dropdown"
                              [items]="communityList"
                              bindLabel="SelectionDisplay"
                              bindValue="SelectionValue"
                              (change)="changeCommunity($event)"
                              [clearable]="false" 
                              [searchable]="false"
                              [(ngModel)]="currentCommunityId" 
                              placeholder="Please Select">
                            <!-- <ng-option *ngFor="let community of communityList" [value]="community.SelectionValue" >{{community.SelectionDisplay}}</ng-option> -->
                          </ng-select>
                        </div>
                      </ng-template>
                    </ng-container>
                  </li>
                  <li class="divider" *ngIf="menuActions.length > 0"></li>
                  <li *ngFor="let menuAction of menuActions">
                    <a class="dropdown-item" (click)="selectMenuAction(menuAction.ActionCommand)">{{menuAction.ActionDisplay}}</a>
                  </li>
                  <li *ngIf="shortHeader">
                    <a class="dropdown-item" (click)="logOutSession()">
                      Sign Out
                    </a>
                  </li>
                  <!-- <li><a class="dropdown-item update-profile" (click)="updateProfile()">Update Profile</a></li>
                  <li><a class="dropdown-item change password" (click)="changePassword()">Change Password</a></li> -->
              </ul>
            </div>
          </li>
          <li class="nav-item" *ngIf="!startPage && !shortHeader">
            <div class="btn-group res" dropdown>
              <button dropdownToggle class="btn dropdown-help arrow-down no-outline" type="button" 
                  id="dropdownMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Help
              </button>
              <ul class="dropdown-menu dropdown-menu-help" *dropdownMenu role="menu" aria-labelledby="dropdownMenu" style="width:auto">
                  <li><a class="dropdown-item" routerLink="/faq">FAQ</a></li>
                  <li *ngIf="userGuidesHtml"><a class="dropdown-item" href="{{userGuidesHtml}}" target="_blank">User Guides</a></li>
                  <li *ngIf="userGuidesBuyer"><a class="dropdown-item" href="{{userGuidesBuyer}}" target="_blank">Buyer User Manual</a></li>
                  <li *ngIf="userGuidesSupplier"><a class="dropdown-item" href="{{userGuidesSupplier}}" target="_blank">Supplier User Manual</a></li>
                  <li><a class="dropdown-item" (click)="startTour()">Take the tour</a></li>
              </ul>
            </div>

            <!-- <button mat-button #matMenuTrigger="matMenuTrigger" [disableRipple]="true" [matMenuTriggerFor]="menu" class="btn-menu-item arrow-down" style="line-height: 27px;">Help</button>
        
            <mat-menu #menu="matMenu" [hasBackdrop]="false" [class]="dropdown-menu-help">
              <button mat-menu-item class="sub-menu-item">
                <a routerLink="/faq">FAQ</a>
              </button>
              <button mat-menu-item class="sub-menu-item">
                <a href="../../assets/html/WelcometoMyBizeProcurementPortal.html" target="_blank">User Guides</a>
              </button>
              <button mat-menu-item class="sub-menu-item" (click)="startTour()">
                Take the tour
              </button>
            </mat-menu> -->
          </li>
          <!-- <li class="nav-item" *ngIf="shortHeader">
            <div class="user-guide-flag" style="padding: 0 5px 0 8px;" title="User Guide">
            <mat-icon class="user-guide-icon">live_help</mat-icon></div>
          </li> -->
          <li #trayicon *ngIf="!startPage" [ngClass]="{'nav-item': true, 'light': !toggleTray, 'dark': toggleTray}" (click)="showNotification()">
            <!-- <div [ngClass]="{'notification-ic' : true, 'hasNotifications':hasNotification}">
              <i [ngClass]="{'fa fa-bell': true}"></i>
              <span *ngIf="hasNotification" class="notification-count">{{ notificationCount < 100 ? notificationCount : '99+' }}</span>
            </div> -->
            <div [ngClass]="{'notification-ic' : true, 
            'hasNotifications':hasNotification, 'short-noti': shortHeader}"
            title="Notifications"> 
              <div [class.hide]="notificationCount == 0" matBadge="{{notificationCount < 100 ? notificationCount : '99'}}" matBadgePosition="after" matBadgeColor="accent">
                <i [ngClass]="{'fa fa-bell': true}"></i>
              </div>
            </div>
          </li>
          <li class="nav-item" *ngIf="!shortHeader || startPage">
            <a id="logout" (click)="logOutSession()">
              Sign Out
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>
<ng-template #loginNav>
  <nav class="navbar navbar-light fixed-top navbar-expand-lg login-navbar">
    <div class="new-div">
      <a class="navbar-brand logo" routerLink="/login" (click)="displayMenu = true">
        <img src='../../assets/images/portal_logo.png' />
      </a>
      <button [ngClass]="{'navbar-toggler' : true, 'collapsed' : !loginNavbarOpen }" type="button" data-toggle="collapse" data-target="#navbarCollapse" 
      (click)="toggleLoginNavbar()" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
        <span class="icon-bar top-bar"></span>
        <span class="icon-bar middle-bar"></span>
        <span class="icon-bar bottom-bar"></span>
        <span class="sr-only">Toggle navigation</span>
      </button>
      <div [ngClass]="{'collapse':true, 'navbar-collapse':true, 'show': loginNavbarOpen}" id="navbarCollapse" style="float:right" *ngIf="displayMenu">
        <ul class="mb-right-shift navbar-nav ml-auto">
          <ng-container *ngFor="let order of headersOrder">
            <ng-container *ngIf="order == 'allowSupplierApplication'">
              <li *ngIf="userGuide">
                <a class="header-links user-guide" routerLink="/vendor-applications"
                [routerLinkActive]="'is-active'">
                <svg height="16" viewBox="0 0 16 16" width="16">
                  <g fill="none" fill-rule="evenodd" transform="translate(1)">
                    <circle cx="7" cy="8" r="7" stroke="currentColor"></circle>
                    <path fill="currentColor" d="m6.871 3.992c-.814 0-1.452.231-1.914.704-.462.462-.693 1.089-.693 1.892h1.155c0-.484.099-.858.297-1.122.22-.319.583-.473 1.078-.473.396 0 .715.11.935.33.209.22.319.517.319.902 0 .286-.11.55-.308.803l-.187.209c-.682.605-1.1 1.056-1.243 1.364-.154.286-.22.638-.22 1.045v.187h1.177v-.187c0-.264.055-.506.176-.726.099-.198.253-.396.462-.572.517-.451.825-.737.924-.858.275-.352.418-.803.418-1.342 0-.66-.22-1.188-.66-1.573-.44-.396-1.012-.583-1.716-.583zm-.198 6.435c-.22 0-.418.066-.572.22-.154.143-.231.33-.231.561 0 .22.077.407.231.561s.352.231.572.231.418-.077.572-.22c.154-.154.242-.341.242-.572s-.077-.418-.231-.561c-.154-.154-.352-.22-.583-.22z"></path>
                  </g>
                </svg>{{userGuide}}</a>
              </li>
            </ng-container>
            <ng-container *ngIf="order == 'allowContactUs'">
              <li *ngIf="allowContactUs"><a routerLink="/contact-us" class="header-links rs-contact-us" 
                [routerLinkActive]="'is-active'">{{allowContactUs}}</a></li>
            </ng-container>
          </ng-container>
          <li *ngIf="allowRegistration">
            <a routerLink="/supplier-registration" class="btn rs-register-supplier waves-ripple">
              {{allowRegistration}}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</ng-template>